import Lookup from 'src/componentes/select2';

const GeneroLookup = ({ ...rest }) => (
  <Lookup labelKey="descricao" valueKey="id" url="/GeneroLookup" {...rest} />
);

export default GeneroLookup;
